import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledImg = styled("img")({
  height: "2.125rem",
  maxWidth: "10rem"
});

export const StyledImgBox = styled(Box)<{ $isFreya?: boolean }>`
  @media (max-width: 600px) {
    ${({ $isFreya }) => ($isFreya ? "display: block;" : "display:none")}
  }
`;

export const StyledBox = styled(Box)`
  width: 12.875rem;

  @media (max-width: 600px) {
    width: 8rem;
  }
`;
